import Spinner from '@/components/ui/Spinner.tsx';

export const LoadingIndicator = () => (
  <div className={'flex items-center justify-center py-80'}>
    <Spinner className={'size-14'} />
  </div>
);
